import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {StringUtils} from "./string.utils";

@Pipe({name: 'stringFormat'})
export class StringFormatPipe implements PipeTransform {

  transform(aText: string, ... aParams): any {
    return StringUtils.format(aText, aParams);
  }
}